import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { GenericRegex } from '../../../constants/generic-regex.constants';
import { OrderProvider } from '../../../providers/orders/order-provider.service';
import { Order, SearchOrder, Shipper } from '../../../interfaces';
import { SearchOrderClientComponentLabels, SearchOrderLabels } from './search-order-client.labels';
import { ShipperProvider } from '../../../providers/shipper/shipper-provider.service';
import { ToastrAlertsService } from '../../../services/utils/toastr-alerts.service';

const PUBLIC_ACCESS_PARAM = 'publicAccessAccounts';
const SLASH = '/';
const ORDER_HISTORIC_ROUTE = 'search-order/order-tracking';

@Component({
  selector: 'app-search-order-client',
  templateUrl: './search-order-client.component.html',
  styleUrls: ['./search-order-client.component.scss', '../../../app.component.scss']
})
export class SearchOrderClientComponent implements OnInit {
  public labels: SearchOrder;
  public orderId: string;
  public orderFound: Array<Order>;
  public searchingOrder: boolean;
  public searchOrderDataForm: FormGroup;
  public shipper: Shipper;
  public shipperOid: string;
  public showHistoricOrder: boolean;

  constructor(
    private readonly builder: FormBuilder,
    private orderProvider: OrderProvider,
    private router: Router,
    private shipperProvider: ShipperProvider,
    private toast: ToastrAlertsService
  ) {
    this.searchingOrder = false;
    this.labels = SearchOrderClientComponentLabels;
    this.showHistoricOrder = false;
  }

  /**
   * @description Event fires when init component
   */
  public ngOnInit(): void {
    this.initForm();
  }

  /**
   * @description Inits form
   */
  public initForm(): void {
    this.searchOrderDataForm = this.builder.group({
      orderIdentifier: new FormControl(null, [Validators.required, Validators.maxLength(25), Validators.pattern(GenericRegex.noBlanks)])
    });
  }

  /**
   * @description Go to Order Historic Client component
   */
  public goTo(): void {
    const  query ={
      queryParams: {
        folio: this.orderId,
        shipperOid: this.shipperOid
      }
    };
    this.router.navigateByUrl(SLASH, { skipLocationChange: true }).then(() =>
      this.router.navigate([ORDER_HISTORIC_ROUTE], query));
  }

  /**
   * @description Starts the proccess to search the current order
   */
  public async searchOrder(): Promise<void> {
    try {
      this.toast.processingAlert();
      this.searchingOrder = true;
      this.orderId = this.searchOrderDataForm.value.orderIdentifier.trim();
      this.orderFound = await this.orderProvider.getOrderClient(this.orderId);
      if (!this.orderFound) {
        this.toast.warningAlert(SearchOrderLabels.notFoundOrder);
        this.searchingOrder = false;
      } else {
        this.shipperOid = this.orderFound[0].shipperId;
        this.shipper = await this.shipperProvider.getShipperByOid(this.shipperOid);
        const shipperAccountsAvaible = this.shipper.configuracion[PUBLIC_ACCESS_PARAM];
        if (shipperAccountsAvaible.length && (shipperAccountsAvaible.find(account =>
            account._id === this.orderFound[0].account['_id']))) {
          this.showHistoricOrder = true;
          this.goTo();
        } else {
          this.toast.warningAlert(SearchOrderLabels.notFoundOrder);
          this.searchingOrder = false;
        }
      }
    } catch (error) {
      this.searchingOrder = false;
      this.toast.errorAlert(SearchOrderLabels.errorGettingOrder);
    } finally {
      this.toast.closeProcessing();
    }
  }

}
